import { StyleSheet, Dimensions } from "react-native";
import color from "@constants/color";
import metrics from "@constants/metrics";
import { fontFamily } from "@utils/styles";

const HEIGHT = Dimensions.get("window").height;

export default StyleSheet.create({
  rowPadding: {
    paddingVertical: 8,
  },
  section: {
    flex: 1,
    padding: 24,
    backgroundColor: "#fefeff",
    paddingTop: 0,
    paddingBottom: 50,
  },
  flexAndRow: {
    display: "flex",
    flexDirection: "row",
  },
  teamLeaderContainer: {
    backgroundColor: color.darkBackground,
    fontFamily: fontFamily.regular,
  },
  topText: {
    fontSize: 20,
    lineHeight: 32,
  },
  shippingDetails: {
    color: "#000",
    opacity: 0.56,
    paddingHorizontal: 8,
  },
  topBarContainer: {
    width: "100%",
  },
  searchBar: {
    height: 44,
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.4)",
    borderRadius: 10,
    alignItems: "center",
    flex: 1,
    backgroundColor: "white",
  },
  searchInput: {
    marginLeft: 8,
    fontSize: 16,
    lineHeight: 24,
    color: "rgba(0,0,0,0.86)",
    flex: 1,
  },
  searchIconContainer: {
    // position: "absolute",
    // left: 5,
    // top: 5,
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 10,
    marginLeft: 10,
    width: 18,
  },
  orderBtnContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  orderBtn: {
    backgroundColor: color.primary,
    padding: 10,
    borderRadius: 30,
    width: 126,
  },
  orderBtnText: {
    color: "#fff",
    paddingHorizontal: 8,
    fontSize: 12,
  },
  infoContainer: {
    width: "100%",
    justifyContent: "space-between",
  },
  iconContainer: {
    alignItems: "center",
  },
  iconText: {
    paddingHorizontal: 10,
  },
  editBtn: {
    color: color.primary,
    fontWeight: "bold",
    lineHeight: 20,
  },
  leaderName: {
    color: "rgba(0, 0, 0, 0.86)",
    paddingVertical: 8,
  },
  leaderAddress: {
    color: "rgba(0, 0, 0, 0.56)",
  },
  customerTotal: {
    fontWeight: "bold",
    color: "rgba(0, 0, 0, 0.56)",
    fontSize: 14,
  },
  customerContainer: {
    // paddingTop: 10,
    // borderBottomColor: "#ddd",
    // borderBottomWidth: 1
  },
  customerName: {
    fontSize: 20,
    color: "rgba(0, 0, 0, 0.86)",
  },
  customerCreationDate: {
    fontSize: 14,
    color: "rgba(0, 0, 0, 0.56)",
  },
  customerNumber: {
    color: "rgba(0, 0, 0, 0.56)",
    paddingHorizontal: 10,
  },
  customerOrderInfoContainer: {
    alignItems: "center",
  },
  orderInfo: {
    color: color.primary,
    fontWeight: "bold",
    fontSize: 18,
  },
  orderInfoText: {
    paddingHorizontal: 10,
    color: color.primary,
    fontSize: 14,
  },
  addUserBtn: {
    height: 56,
    width: 56,
    borderRadius: 56 / 2,
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    elevation: 10,
    right: 24,
    bottom: 10,
    overflow: "hidden",
  },
  addButtonContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: 10,
    backgroundColor: color.primary,
    width: metrics.screenWidth * 0.9,
    height: 50,
    borderRadius: 10,
    marginTop: 20,
  },
  userContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    margin: 10,
  },
  whatsapp: {
    // flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  syncModal: {
    backgroundColor: "rgba(0, 0, 0, .8)",
    paddingVertical: 16,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    height: HEIGHT,
  },
  syncModalContainer: {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 10,
    width: "80%",
  },
  syncContactButton: {
    backgroundColor: color.primary,
    padding: 8,
    borderRadius: 3,
    marginVertical: 10,
  },
  newContainer: {
    position: "absolute",
    backgroundColor: color.lima1,
    top: 0,
    left: 0,
    width: metrics.screenWidth / 5,
    height: metrics.screenHeight / 26,
    maxHeight: 20,
    maxWidth: 60,
    padding: 10,
    justifyContent: "center",
    alignItems: "center",
    borderBottomEndRadius: 10,
  },
  installContainer: {
    paddingTop: 10,
  },
});
